import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { TextField, Button } from "@material-ui/core";
import Axios from "axios";
import ReactLoading from "react-loading";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { url } from "../../../config/config";
import { useStyles } from "./ResetPassword.css";

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      oldPasswordError: "",
      newPasswordError: "",
      confirmPasswordError: "",
      showPassword: false,
      showConfirmPassword: false,
      success: "",
      error: true,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  showPassword = () => {
    return (
      <VisibilityIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  showConfirmPassword = () => {
    return (
      <VisibilityIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: true })}
      />
    );
  };

  hideConfirmPassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: false })}
      />
    );
  };

  checkError = () => {
    let newPasswordError = "";
    let confirmPasswordError = "";

    if (this.state.data.newPassword.length < 8) {
      newPasswordError = "Password must be minimum of 8 characters";
    }
    if (this.state.data.confirmPassword !== this.state.data.newPassword) {
      confirmPasswordError = "Password must be matched";
    }

    if (newPasswordError || confirmPasswordError) {
      this.setState({
        newPasswordError,
        confirmPasswordError,
      });
      return true;
    } else {
      this.setState({
        newPasswordError: "",
        confirmPasswordError: "",
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    this.setState({ error: errorStatus });
    if (errorStatus === false) {
      if (this.props.match.params.type === "Customer") {
        const response = await Axios.post(
          `${url}/api/users/password/reset/${this.props.match.params.id}/${this.props.match.params.token}`,
          { password: this.state.data.newPassword }
        );
        if (response.data.success) {
          this.setState({
            success: response.data.success,
          });
          this.props.history.push(`/login/${this.props.match.params.type}`);
        } else {
          this.setState({
            error: true,
          });
        }
      }
      if (this.props.match.params.type === "Author") {
        const response2 = await Axios.post(
          `${url}/api/authors/password/reset/${this.props.match.params.id}/${this.props.match.params.token}`,
          { password: this.state.data.newPassword }
        );
        if (response2.data.success) {
          this.setState({
            success: response2.data.success,
          });
          this.props.history.push("/login");
        } else {
          this.setState({
            error: true,
          });
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <form onSubmit={this.handleSubmit}>
          Reset Password
          <TextField
            name="newPassword"
            type={this.state.showPassword ? "text" : "password"}
            label="New Password"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            style={{ outline: "none" }}
            placeholder="Enter your new password"
            error={this.state.newPasswordError ? true : false}
            helperText={this.state.newPasswordError}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showPassword
                ? this.hidePassword()
                : this.showPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.newPassword}
            onChange={this.handleChange}
          />
          <TextField
            name="confirmPassword"
            type={this.state.showConfirmPassword ? "text" : "password"}
            label="Confirm Password"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            style={{ outline: "none" }}
            placeholder="Confirm your password"
            error={this.state.confirmPasswordError ? true : false}
            helperText={this.state.confirmPasswordError}
            InputProps={{
              classes: {
                root: classes.inputRoot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
              endAdornment: this.state.showConfirmPassword
                ? this.hideConfirmPassword()
                : this.showConfirmPassword(),
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.confirmPassword}
            onChange={this.handleChange}
          />
          <Button
            type="submit"
            variant="outlined"
            className={classes.buttonStyle}
          >
            Confirm
          </Button>
          {!this.state.success && this.state.error === false && (
            <div>
              Updating...
              <ReactLoading type={"bubbles"} color="black" />
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(ResetPassword));
